import { useCallback } from 'react'
import {
  errorMessage,
  errorValues,
  type FieldErrors,
  type WizardDraft,
} from '../../lib/company-wizard'
import { useI18n } from '../../lib/i18n'

/** What every step of the wizard gets from the page that holds the draft. */
export interface StepProps {
  draft: WizardDraft
  errors: FieldErrors
  /**
   * Changes the draft. The problems of `fields` go: the person is correcting them (the page
   * checks the step again before going on).
   */
  change: (update: (draft: WizardDraft) => WizardDraft, fields: readonly string[]) => void
}

/** A field's problem, in the page's language; null while it has none. */
export function useFieldError(errors: FieldErrors): (field: string) => string | null {
  const { t } = useI18n()
  return useCallback(
    (field: string) => {
      const code = errors[field]
      return code ? t(errorMessage(field, code), errorValues(code)) : null
    },
    [errors, t],
  )
}
